export class PaymentModel{
    paymentMethodToken: string;
    membershipPlanCode: string;
    membershipPlanId: string;
    code: string;
    ZipCodes: string;
    promoCode: string;
}

export class RealtorPlan {
    description: string;
    code: string;
    title: string;
    membershipId: number;
    frequency: string;
    price: string;
    membershipType: string;
    featureSet: { AllowZipCodes?: string; [key: string]: any };
    promoCode: string;
    uid: string;
    isa: boolean;
    planCategoryDescription: string;
    limits: {
        MaxZipCodeAllowed: number;
    };
    selected: boolean;
    currentPlanStatus?: string;
    currentPlanHoldStartDate?: string;
    currentPlanPromoCode?: string;
  }